module.exports = __webpack_public_path__ + "static/media/3.7d25a0d1.jpg";